﻿export default class NotificationViewModel {
    public id: number = 0;
    public title: string = '';
    public subTitle: string = '';
    public body: string = '';
    public timeStamp: Date = new Date();
}